import circleIcon from "../../assets/icons/Ellipse 81.png";
import { Checkbox } from "../index";
import Table from "../table/Table";
import { useGroups } from "../../data/live";

const formatDate = (value) => {
  if (!value) return "Not available";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Not available";
  return date.toLocaleDateString("en-AU", { day: "numeric", month: "long" });
};

const money = (amount, currency) =>
  `${Number(amount || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${currency || ""}`.trim();

const AllGroups = () => {
  const { items: groups, loading } = useGroups();
  const allGroupTableBody = groups.map((group) => {
    const last = group.lastActivity;
    return {
      groupDetail: {
        icon: circleIcon,
        name: group.name,
        createdOn: formatDate(group.createdAt),
      },
      category: group.category || last?.category || "Not set",
      tags: Array.isArray(group.tags) && group.tags.length ? group.tags : last?.tags || [],
      lastActivity: {
        paidBy: last?.paidBy || "No activity",
        paidTo: group.name,
        amount: last ? money(last.amount, last.currency) : "",
        date: last ? formatDate(last.date) : "",
      },
      totalExpensesnGroup: money(group.totalExpenses, group.totalCurrency),
    };
  });

  const allGroupTableHeaders = [
    <Checkbox />,
    "Group Name",
    "Category",
    "Tags",
    "Last Activity",
    "Total Expenses in Group",
  ];

  return (
    <>
      <div className="col-12">
        <div className="p-3 px-4 rounded-3 border mt-3">
          {loading ? (
            <div className="p-5 text-center text-muted">Loading groups...</div>
          ) : allGroupTableBody.length ? (
            <Table
              tableBody={allGroupTableBody}
              tableHeaders={allGroupTableHeaders}
              AllGroupsTable={true}
              keyNumber1={1}
              condition1={"col-2"}
              condition2={""}
              className={"w-100"}
            />
          ) : (
            <div className="p-5 text-center text-muted">No groups found.</div>
          )}
        </div>
      </div>
    </>
  );
};

export default AllGroups;
